import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_FEEDER_SERVICE_WAREHOUSE_LIST:
      return { ...action.warehouseList };
    default:
      return state;
  }
};
